// COPIA da TMA#718 di CriGio @ 18f1ef07d0fe7bf6a63c2730ac049e52c705f67e: src/lib/burraco/schermo.ts
/** Un ambiente senza schermo (jsdom, un banco): nessun `matchMedia`. Li il tavolo e il resoconto restano il palco approvato, come li conoscono i test. */
export const senzaSchermo = (): boolean => typeof window === 'undefined' || typeof window.matchMedia !== 'function';
